import React from 'react';
import axios from 'axios';

// add the api key to all axios requests
axios.defaults.headers.common = {
  'x-api-key': '1cf7c91905b55dc4bda0',
};

class APIExplorer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: '' };
  }

  getData = async (urlString) => {
    let url = '';
    switch (urlString) {
      case 'topItems':
        url = 'https://marketshareapi.ascentialedge.com/clients/556cae9a2361c/reports/top_items?start_date=2019-10-06&end_date=2020-01-04&number_of_items=4';
        break;
      case 'salesDrivers':
        url = 'https://marketshareapi.ascentialedge.com/clients/556cae9a2361c/reports/sales_drivers_top_items?start_date=2019-10-06&end_date=2020-01-04&number_of_items=4&include_vat=0';
        break;
      case 'mySalesDrivers':
        url = 'https://marketshareapi.ascentialedge.com/clients/556cae9a2361c/reports/my_sales_drivers?start_date=2019-10-06&end_date=2020-01-04&include_vat=0&rollup=week';
        break;
      case 'salesPeriodCumulative':
        url = 'https://marketshareapi.ascentialedge.com/clients/556cae9a2361c/reports/sales_period_cumulative?start_date=2019-10-06&end_date=2020-01-04&rollup=week&include_vat=0';
        break;
      case 'myShareChart':
        url = 'https://marketshareapi.ascentialedge.com/clients/556cae9a2361c/reports/my_share_chart?start_date=2019-10-06&end_date=2020-01-04&rollup=week';
        break;
      default:
        this.setState({ data: '' });
        return;
    }

    this.setState({ data: 'loading' });
    axios.get(url).then((data) => this.setState({ data: data.data }));
  }

  getSalesDrivers

  render() {
    const { data } = this.state;
    return (
      <ul style={{ 'text-align': 'center', 'line-height': '30px' }}>
        {<li><a onClick={() => this.getData('topItems')} disabled={this.state.data === "loading"}>Get Top Items</a></li> /* eslint-disable-line */}
        {<li><a onClick={() => this.getData('salesDrivers')} disabled={this.state.data === "loading"}>Get Sales Drivers</a></li>  /* eslint-disable-line */}
        {<li><a onClick={() => this.getData('mySalesDrivers')} disabled={this.state.data === "loading"}>Get My Sales Drivers</a></li>  /* eslint-disable-line */}
        {<li><a onClick={() => this.getData('salesPeriodCumulative')} disabled={this.state.data === "loading"}>Get Sales Period Cumulative</a></li>  /* eslint-disable-line */}
        {<li><a onClick={() => this.getData('myShareChart')} disabled={this.state.data === "loading"}>Get My Share Chart</a></li>  /* eslint-disable-line */}
        <pre>{JSON.stringify(data, null, 2)}</pre>
      </ul>
    );
  }
}

export default APIExplorer;
